module.exports = __webpack_public_path__ + "img/progress-ring.84c6f1cd.png";